import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { Image } from '@dtx-company/shared-components/src/components/atoms/Image/index'
import { LockedFeaturesUpsellContentType } from '../../constants/lockedFeatures'
import NextImage from 'next/image'

export const PromoAsset = ({
  graphic
}: {
  graphic: LockedFeaturesUpsellContentType | undefined
}): JSX.Element | null => {
  if (!graphic?.src) return null
  if (graphic.width && graphic.height) {
    return (
      <NextImage
        src={graphic.src}
        alt={graphic.alt || ''}
        height={graphic.height}
        width={graphic.width}
      />
    )
  }
  return (
    <Box position={'relative'} m={'auto'} width={250}>
      <Image src={graphic.src} alt={graphic.alt} />
    </Box>
  )
}
